<script>
import { mapState } from 'vuex';
import Popup from '../../components/mineTable/popup.vue';

export default {
    name: "pay",
    data() {
        return {
            // 支付方式列表
            payTypeList: [
                { id: 1, name: '支付宝' },
                { id: 2, name: '微信' },
                // { id: 3, name: 'Pay Pal' },
            ],
            paytype: 1,
            detail: {},
            payQrcode: '',
            isShowPayQrcode: false,
        };
    },
    computed: {
        ...mapState(['isVip']),
    },
    components: {
        Popup
    },
    mounted() {
        this.getOrderDetail();
    },
    destroyed() {},
    watch: {},
    methods: {
        // 获取订单详情
        getOrderDetail() { 
            // 2026012614002419009
            this.$store.dispatch('getShopOrderDetail', {
                order_code: this.$route.query.code
            }).then((result) => {
                if (result.code == 100) {
                    this.detail = result.data;
                    this.detail.item = this.detail.item.map(v => ({
                        ...v,
                        total_price: (parseFloat(v.price) * v.qty).toFixed(2)
                    }));
                } else if (result.code == 90) { 
                    this.toLogin();
                }
            }).catch((err) => {
                this.$showToast({ text: err.message || '获取订单详情失败' });
            });
        },
        // 跳转登录
        toLogin() { 
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },
        // 确认付款
        confirmPay() { 
            if (this.detail.pay_status != 0) {
                this.$showToast({ text: '该订单已支付' });
                return;
            }
            // 获取支付二维码
            this.$store.dispatch('getShopOrderPay', {
                order_code: this.detail.order_code,
                type: this.paytype,
            }).then((result) => {
                if (result.code == 100) {
                    // 显示支付二维码
                    this.payQrcode = result.data;
                    this.isShowPayQrcode = true;
                } else if (result.code == 90) { 
                    this.toLogin();
                } else {
                    this.$showToast({ text: result.msg || '获取支付二维码失败' });
                }
            }).catch((err) => {
                this.$showToast({ text: err.message || '获取支付二维码失败' });
            });
        },
        // 刷新支付状态
        refreshPayStatus() { 
            this.$store.dispatch('getShopOrderPayStatus', {
                order_code: this.detail.order_code,
            }).then((result) => {
                if (result.code == 100) {
                    if (result.data == 1) {
                        this.$showToast({ text: '支付成功' });
                        this.detail.pay_status = 1;
                        this.isShowPayQrcode = false;
                    } else {
                        this.$showToast({ text: '支付未完成，请稍后再试' });
                    }
                } else if (result.code == 90) { 
                    this.toLogin();
                } else {
                    this.$showToast({ text: result.msg || '获取支付状态失败' });
                }
            }).catch((err) => {
                this.$showToast({ text: err.message || '获取支付状态失败' });
            });
        },
    },
};
</script>

<template>
    <div class="pay">
        <p class="order_code">订单编号：{{ detail.order_code }}</p>
        <div class="list">
            <div class="item flex" v-for="(item, index) in detail.item" :key="index">
                <router-link :to="item.type == 1 ? `/shop/detail?id=${item.goods_id}` : `/gallery/works/detail?id=${item.item_id}`">
                    <div class="layout_bg cover" :style="`background-image: url(${item.item_image});`"></div>
                </router-link>
                <div class="content flex flex_column justify_between">
                    <div class="info">
                        <p class="name"><router-link :to="item.type == 1 ? `/shop/detail?id=${item.item_id}` : `/gallery/works/detail?id=${item.item_id}`">{{ item.item_name }}</router-link></p>
                        <p class="price">RMB {{ item.price }}</p>
                        <div class="count">x{{ item.qty }}</div>
                    </div>
                    <div class="bottom flex justify_end align_center">
                        <p class="price">实际付款 RMB {{ item.total_price }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="shopping_price flex justify_end">
            <div class="content">
                <!-- <div class="row price_wrap flex justify_between">
                    <p class="name">小计：</p>
                    <p class="price">RMB </p>
                </div> -->
                <div class="row price_wrap flex justify_between">
                    <p class="name">运费：</p>
                    <p class="price">RMB {{ detail.freight }}</p>
                </div>
                <div class="row price_wrap flex justify_between">
                    <p class="name">总计：</p>
                    <p class="price">RMB {{ detail.amount }}</p>
                </div>
                <p class="row text" v-if="isVip">已享A+Studio Shop 会员10%优惠</p>
            </div>
        </div>
        <!-- 未支付 -->
        <template v-if="detail.pay_status == 0">
            <!-- 付款方式 -->
            <div class="pay_type">
                <p class="title">付款方式</p>
                <div class="options flex">
                    <div class="option flex align_center" v-for="(item, index) in payTypeList" :key="index" @click="paytype = item.id">
                        <div class="checkbox" :class="{ active: paytype == item.id }"></div>
                        <p>{{ item.name }}</p>
                    </div>
                </div>
            </div>
            <!--  -->
            <!-- <div class="flex">
                <div class="btn_pay layout_flex_center" @click="confirmPay">确认付款</div>
            </div> -->
            <div class="shopping_price flex justify_end">
                <div class="content">
                    <div class="btn layout_flex_center" @click="confirmPay">确认付款</div>
                </div>
            </div>
        </template>
        <!-- 已支付 -->
        <template v-else>
            <!-- <div class="pay_success">
                <p class="text">该订单已支付，感谢您的购买！</p>
                <router-link class="btn_pay layout_flex_center" to="/mine/order">查看订单列表</router-link>
            </div> -->
            <div class="shopping_price flex justify_end">
                <div class="content">
                    <p class="row text">该订单已支付，感谢您的购买！</p>
                    <router-link class="btn layout_flex_center" to="/mine/order">查看订单列表</router-link>
                </div>
            </div>
        </template>
        <!-- 支付二维码 -->
        <Popup title="支付二维码" :show="isShowPayQrcode" :isShowClose="true" @close="isShowPayQrcode = false">
            <div class="layout_flex_center flex_column">
                <p class="p1">请使用{{ payTypeList.find(v => v.id == paytype).name }}扫码支付</p>
                <img class="qrcode" v-if="payQrcode" :src="payQrcode"></img>
                <p class="p2" v-else>二维码加载中...</p>
                <!-- 点击刷新 -->
                <p class="btn_refresh" @click="refreshPayStatus">支付完成，点击刷新</p>
            </div>
        </Popup>
    </div>
</template>

<style scoped lang="scss">
.pay{
    // .pay_success{
    //     padding: .3rem 0;
    //     font-size: .18rem;
    //     .text{
    //         margin-bottom: .2rem;
    //     }
    // }
    .qrcode{
        width: 4rem;
        height: 4rem;
        background-size: 100% 100%;
        margin: .4rem 0;
    }
    .btn_refresh{
        margin-top: .4rem;
        font-size: .18rem;
        color: var(--font_color);
        cursor: pointer;
        border: 1px solid var(--font_color);
        padding: .1rem .3rem;
        border-radius: .1rem;
    }
    .order_code{
        font-size: .16rem;
        color: #666;
        @media screen and (max-width: 750px) {
            font-size: .26rem;
        }
    }
    // .btn_pay{
    //     width: 2.4rem;
    //     height: .45rem;
    //     border: 1px solid var(--font_color);
    //     border-radius: .1rem;
    //     font-size: .16rem;
    //     background: var(--font_color);
    //     color: #fff;
    //     cursor: pointer;
    // }
    .pay_type{
        padding: .3rem 0;
        .title{
            font-size: .25rem;
            font-weight: bold;
            margin-bottom: .2rem;
        }
        .options{
            font-size: .16rem;
            .option{
                cursor: pointer;
                margin-right: .3rem;
                .checkbox{
                    width: .24rem;
                    height: .24rem;
                    border: 1px solid var(--font_color);
                    border-radius: 50%;
                    margin-right: .1rem;
                    &.active{
                        &::after{
                            content: '';
                            display: block;
                            width: .16rem;
                            height: .16rem;
                            background-color: var(--font_color);
                            border-radius: 50%;
                            margin: .03rem;
                        }
                    }
                }
            }
        }
    }
}
</style>